import { useEffect } from 'react'
import { Box, useTheme } from '@material-ui/core'
import { track, useTracking } from 'lib/babylistHealthAnalytics'
import { useLayout } from '../../../widgets/Layout'
import InsuranceVerificationFailedV2 from './InsuranceVerificationFailedV2'
import InsuranceVerificationFailedV1 from './InsuranceVerificationFailedV1'
import useStyles from './InsuranceVerificationFailed.styles'
import { InsuranceFormSuccessCallback } from '../../../forms/InsuranceForm/InsuranceForm'
import { STORE_NAME } from '../../../constants'

interface InsuranceVerificationFailedProps {
  customerId: APIResponse.Customer['id']
  onSuccess: InsuranceFormSuccessCallback
}

const InsuranceVerificationFailed = (
  props: InsuranceVerificationFailedProps
) => {
  const layout = useLayout()
  const classes = useStyles()
  const theme = useTheme()
  const tracker = useTracking()
  const isNewInsuranceFlowEnabled = !!layout?.replacementPartsNewInsurance

  useEffect(() => {
    tracker.trackEvent({
      event: track.replacementPartsOrderBlockerViewed,
      blockerType: 'INSURANCE_VERIFICATION_FAILED',
      storeName: STORE_NAME,
    })
  }, [])

  return (
    <Box
      bgcolor={theme.palette.background.contrast}
      flexGrow={1}
      pb={8}
      pt={4}
      px={{ xs: 4, sm: 0 }}
    >
      <Box className={classes.container}>
        {isNewInsuranceFlowEnabled ? (
          <InsuranceVerificationFailedV2 {...props} />
        ) : (
          <InsuranceVerificationFailedV1 />
        )}
      </Box>
    </Box>
  )
}

export default InsuranceVerificationFailed
